function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-event-listener/node_modules/@babel/runtime/helpers/builtin/classCallCheck.js
// module id = 1791
// module chunks = 0